import { uniq } from 'lodash';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import Stats from './Stats';

interface DrawStatsProps {
    draws: Draw[];
    mergeDraws?: boolean;
}

function DrawStats({ draws, mergeDraws = false, ...props }: DrawStatsProps) {
    const stats = useMemo(() => {
        if (draws === null || draws.length === 0) {
            return null;
        }
        const participationsCounts =
            draws !== null
                ? uniq(
                      draws
                          .map(({ participationsCount = 0 }) => participationsCount)
                          .filter((count) => count > 0),
                  )
                : null;
        return mergeDraws && participationsCounts !== null && participationsCounts.length > 1
            ? [
                  {
                      value: `+${
                          participationsCounts[0] < 10
                              ? `${participationsCounts[0]}`
                              : participationsCounts[0]
                      }`,
                      label:
                          participationsCounts[0] > 1 ? (
                              <FormattedMessage
                                  defaultMessage="Additional entries into the draws"
                                  description="Game results stats label"
                              />
                          ) : (
                              <FormattedMessage
                                  defaultMessage="Additional entry into the draws"
                                  description="Game results stats label"
                              />
                          ),
                  },
              ]
            : draws
                  .filter(({ participationsCount = 0 }) => participationsCount > 0)
                  .map((draw) => {
                      const { title, participationsCount } = draw;
                      return {
                          draw,
                          value: `+${
                              participationsCount < 10
                                  ? `${participationsCount}`
                                  : participationsCount
                          }`,
                          label:
                              participationsCount > 1 ? (
                                  <FormattedMessage
                                      defaultMessage="Additional entries into the {title} draw"
                                      description="Game results stats label"
                                      values={{
                                          title,
                                      }}
                                  />
                              ) : (
                                  <FormattedMessage
                                      defaultMessage="Additional entry into the {title} draw"
                                      description="Game results stats label"
                                      values={{
                                          title,
                                      }}
                                  />
                              ),
                      };
                  });
    }, [draws, mergeDraws]);

    return <Stats stats={stats} {...props} />;
}

export default DrawStats;
